export interface GlobalFilter {
  firm_type?: string;
  category?: string[];
  brand?: string[];
  manufacturing_network?: string[];
  start_year?: any;
  end_year?: any;
  node_type?: string[];
  node_code?: string[];
  plant_code?: string[];
  geography?: any;
  line_code?: any;
  product_format?: any;
  pack_format?: any;
  start_quarter?: string;
  end_quarter?: string;
}

export interface InsightFilter {
  time_frame?: string;
  geography?: string[];
  pack_format?: string[];
  product_format?: string[];
  skuOptions?: string[];
  base?: boolean;
  innovation?: boolean;
  mups?: boolean;
  nonMups?: boolean;
  independent_demand?: boolean;
  dependent_demand?: boolean;
  includeHistoricalData?: boolean;
}

export interface NavParam {
  username: string;
  screen_name: string;
  screen_desc: string;
  supply_mode: string;
  h1?: string;
  screen_icon?: string;
  is_active: boolean;
}

export enum TimeFrameMode {
  YEARLY = 'year',
  QUARTERLY = 'quarter',
}

export enum KPIDashboardScreen {
  FINANCIAL = 'financial',
  OPERATIONAL = 'operational',
}

export enum SupplyMode {
  MANUFACTURING = 'manufacturing',
  LOGISTICS = 'logistics',
}

export enum InsightMode {
  MUPS = 'mups',
  COMMERCIAL_INSIGHTS = 'commercial_insights',
}

export enum AllocationMode {
  SKU = 'sku',
  LINE = 'line',
}

export interface GrpFilter {
  row_group?: string;
  column_group?: string;
  data_category?: string[];
  sort_by?: string[];
  ascending?: boolean;
}

export interface ExpandableTable {
  order?: number;
  node_type?: string | number;
  inner_child_present?: boolean;
  data_key: string;
  precision: number;
  isExpanded: boolean;
  level: number;
  children?: any[];
  decimalPositions?: number;
  node_name: string;
  child_node_name?: string;
  inner_child_node_name?: string;
}
